<template>

  <!--头部-->
  <div class="header">
    <div class="theHeadWidth">
      <div class="header_top">
        <div class="header_logo">
          <router-link to="/">
            <img src="../assets/image/jiaozhuan_03.png" alt="" />
          </router-link>
        </div>

        <div class="header_search">
          <!-- <span class="theDropdownChoice"> 项目 </span> -->
          <input type="text" class="theSearchInput" placeholder="请输入想搜索的内容...">
          <input type="button" class="searchbutton" value="搜索" />
          <!--@click="atTheTopOfTheSearch(searchData.searchContent)" -->
        </div>

        <div class="header_right" v-if="!userName">
          <span class="loginAvatar">
            <img src="../assets/image/loginico.png" alt="" />
          </span>
          <span class="theHeadLogin">
            <a href="http://120.46.140.235:9011/login?redirect=/index"> 登录</a> </span>
          <!-- <span class="theHeadVerticalBar"></span>
          <span class="theHeadLogin">
            <router-link to="#">注册</router-link>
          </span> -->
        </div>

        <div class="header_right" v-if="userName">
          <span class="loginAvatar">
            <img src="../assets/image/loginico.png" alt="" />
          </span>
          <span class="theHeadLogin">
            <span class="loginName">
              <router-link to="/teachersPersonalCenter">{{
                  userName
              }}</router-link>
            </span>
            <span class="loginOut" @click="loggedOut()">退出</span>
          </span>
        </div>
      </div>
    </div>

    <div class="theFirstNavigation">
      <div class="theHeadWidth">
        <ul class="levelOfClassificationOfUl">

          <li class="navigationLevelClassification" v-if="selectTheNumberOfs == -1"
            @click="returnToTheHomePage(selectTheNumberOfs = -1)">
            首页
            <!-- <span class="homePageStyle"></span> -->
          </li>
          <li class="navigationLevelClassification" @click="returnToTheHomePage(selectTheNumberOfs = -1)" v-else>
            首页
          </li>


          <li class="navigationLevelClassification" v-for="(item, index) in theNavigationDataAcquisition" :key="index"
            @mouseenter="columnClick(item.deptId, index)" @mouseleave="removeTheStyle()">



            <span class=""
              :class="{ trainingCenterStyle: whetherToClickOnTheLower && selectTheNumberOf == index || secondaryToChangeColor == index }">{{
                  item.deptName
              }}

              <span class="nabla" v-if="whetherToClickOnTheLower && selectTheNumberOf == index">
                <img src="../assets/image/daosanjiao.png" alt="">
              </span>
              <span class="theTriangle" v-else>
                <img src="../assets/image/sanjiao.png" alt="">
              </span>
            </span>
            <div class="secondaryNavigationDropdown" v-show="whetherToClickOnTheLower && selectTheNumberOf == index">
              <ul class="theSecondaryClassificationOfUl">
                <li v-for="(items, index) in secondaryNavigationData" :key="index"
                  @click="clickOnTheSecondJump(items.id, items.parentId,)">
                  {{ items.deptName }}
                </li>

              </ul>
            </div>
          </li>
          <li class="navigationLevelClassification"  @mouseenter="columnClick('', 5)" @mouseleave="removeTheStyle()">
            <a href="http://120.46.140.235:9014">
            <span class="aaaa"  :class="{ trainingCenterStyle:selectTheNumberOfs == 5 }">

             实训大数据中心
            </span>
          </a>


          </li>
        </ul>
      </div>
    </div>
  </div>
  <!--头部结束-->



  <div class="classificationOfBackground">
    <!--v-loading="loading"-->
    <div class="content">
      <div class="center_content">
        <form>
          <div class="menu">
            <div class="menubox">
              <div class="sort clearfix"></div>
              <div class="sort clearfix hide2" style="display: block">
                <div class="title">一级目录：</div>
                <div class="classify" data-type="1">
                  <!-- <div style="float: right; margin-top: 5px">
                    <a href="javascript:void(0);" onclick="classify_more()">更多</a>
                  </div> -->
                  <ul class="clearfix">
                    <li @click="clickOnTheClassifications('', -1)" :class="{ on: currentIndex == -1 }">
                      全部
                      <!--{{ allClassificationNumber }}-->
                    </li>
                    <li v-for="(item, index) in professionalGroupOfData" :key="index"
                      :class="{ on: currentIndex == index }"
                      @click="clickOnTheClassification(item.id, index, item.level, item.label)">
                      {{ item.label }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sort clearfix hide2" style="display: block">
                <div class="title">二级目录：</div>
                <div class="classify">
                  <!-- <div style="float: right; margin-top: 5px">
                    <a href="javascript:void(0);" onclick="classify_more()">更多</a>
                  </div> -->
                  <ul class="clearfix">
                    <li @click="theSecondaryClassificationClicksr('', -1)" :class="{ on: currentIndexej == -1 }">
                      全部
                      <!--{{ allClassificationNumber }}-->
                    </li>
                    <li v-for="(item, index) in professionalGroupOfDatas" :key="index"
                      :class="{ on: currentIndexej == index }"
                      @click="theSecondaryClassificationClicks(item.id, index, item.label)">
                      {{ item.label }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sort clearfix hide2" style="display: block">
                <div class="title">三级目录：</div>
                <div class="classify" data-type="1">
                  <!-- <div style="float: right; margin-top: 5px">
                    <a href="javascript:void(0);" onclick="classify_more()">更多</a>
                  </div> -->
                  <ul class="clearfix">
                    <li @click="level3DirectoryClicks('', -1)" :class="{ on: currentIndexsj === -1 }">
                      全部
                      <!--{{ allClassificationNumber }}-->
                    </li>
                    <li v-for="(item, index) in professionalGroupOfDatasr" :key="index"
                      :class="{ on: currentIndexsj == index }"
                      @click="level3DirectoryClick(item.id, index, item.label)">
                      {{ item.label }}
                    </li>
                  </ul>
                </div>
              </div>
              <!-- <div class="sort clearfix hide2" style="display: block">
                <div class="title">四级目录：</div>
                <div class="classify" data-type="1">
               
                  <ul class="clearfix">
                    <li @click="clickOnTheClassification('', 0)" :class="{ on: currentIndex === 0 }">
                      全部
                    
                    </li>
                    <li v-for="(item, index) in professionalGroupOfData" :key="index"
                      :class="{ on: currentIndex === index }" @click="clickOnTheClassification(item.id, index)">
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </div> -->
              <!-- <div class="sort clearfix hide2" style="display: none">
                <div class="title">二级目录：</div>
                <div class="classify">
                  <ul class="clearfix"></ul>
                </div>
              </div>
              <div class="sub-sort">
                <div class="title">课程级别：</div>
                <div class="declareYear">
                  <ul class="clearfix">
                    <li @click="clickOnTheLevel('')" :class="{ on: theCurrentLevel === '' }">
                      全部
                    </li>
                    <li v-for="(item, index) in courseLevel" :key="index" :class="{ on: theCurrentLevel === index }"
                      @click="clickOnTheLevel(index)">
                      {{ item.remark }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sub-sort">
                <div class="title">申报年份：</div>
                <div class="declareYear">
                  <ul class="clearfix">
                    <li :class="{ on: declareTheCurrent === '' }" @click="declareToClick('null')">
                      全部
                    </li>
                    <li :class="{ on: declareTheCurrent === index }" @click="declareToClick(index)">
                      2022
                    </li>
                  </ul>
                </div>
              </div>
              <div class="sub-sort">
                <div class="title">认定年份：</div>
                <div class="declareYear">
                  <ul class="clearfix">
                    <li :class="{ on: asTheCurrent === '' }" @click="decidedToClick('null')">
                      全部
                    </li>
                    <li :class="{ on: asTheCurrent === index }" @click="decidedToClick(index)">
                      2022
                    </li>
                  </ul>
                </div>
              </div> -->
              <div class="sort clearfix">
                <div class="sub-sort">
                  <!-- <div class="title">项目级别：</div>
                <div class="proLevel">
                  <ul class="clearfix" id="project_level">
                    <li
                      class="on"
                      data-id="0"
                      onclick="projectLevelClick(this)"
                    >
                      全部
                    </li>
                    <li data-id="1" onclick="projectLevelClick(this)">
                      认定项目
                    </li>
                    <li data-id="2" onclick="projectLevelClick(this)">
                      其他项目
                    </li>
                  </ul>
                </div> -->
                  <div class="title"><span class="keywords">关键词：</span></div>
                  <div class="edit">
                    <input type="text" v-model="theExperimentalDataRequest.courseName" name="title" placeholder="实验名称">
                    <input type="text" v-model="theExperimentalDataRequest.teacherName" name="schoolTitle"
                      placeholder="主讲教师姓名" class="">

                    <div class="clickSearch" @click="theNameOfTheSearch()">搜索</div>
                  </div>
                </div>
                <!--<div class="sub-sort">
                    <div class="title">
                    获奖年份：
                  </div>
                    <div class="prizeYear">
                    <ul class="clearfix" id="awards_years">
                    <li class="on">全部</li>
                    <li>2018</li>
                    <li>2017</li>
                  </ul>
                  </div>
                  </div>-->
                <div class="sort clearfix"></div>
              </div>
            </div>
          </div>
        </form>
        <div class="sort-container clearfix">

          <div class="accessPath">
            <span class="accessPathHeading">
              访问路径:
            </span>
            <span class="accessPathDropdown">
              <el-select v-model="theSimulationlabel" :placeholder="theSimulationlabel">
                <el-option v-for="(item, index) in professionalGroupOfData" :key="item.label" :label="item.label"
                  :value="item.label" @click="clickOnTheClassification(item.id, index, item.level, item.label)">
                  <span style="float: left">{{ item.label }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
                </el-option>
              </el-select>

            </span>

            <span class="pathOfATriangle" v-show="theSimulationlabels != undefined"> ＞</span>
            <span class="accessPathDropdown" v-show="theSimulationlabels != undefined">
              <el-select v-model="theSimulationlabels" :placeholder="theSimulationlabels">
                <el-option v-for="(item, index) in professionalGroupOfDatas" :key="item.label" :label="item.label"
                  :value="item.label" @click="theSecondaryClassificationClicks(item.id, index, item.label)">
                  <span style="float: left">{{ item.label }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
                </el-option>
              </el-select>

            </span>
            <span class="pathOfATriangle" v-show="theSimulationlabelsr != undefined"> ＞</span>
            <span class="accessPathToTheCurrentLocation" v-show="theSimulationlabelsr != undefined">
              {{ theSimulationlabelsr || '暂无路径' }}
            </span>
          </div>

          <!-- <div class="sort-title">排序：</div>
          <div class="sort-list clearfix" id="sort_list">
            <span :class="theLatestStyle.transform" @click="clickOnTheLatest()">最新</span>
            <span :class="gradingStyle.transform" @click="scoreClick()">评分</span>
            <span :class="collectionStyle.transform" @click="clickOnTheCollection()">收藏</span>
            <span :class="thumbUpStyle.transform" @click="thumbUpClick()">点赞</span>
          </div> -->
        </div>
        <div class="course">
          <div class="noData" v-show="numberOfTraining == 0">暂无数据</div>
          <ul class="clearfix detailsList">
            <li v-for="(item, index) in theExperimentalData" :key="index" @click="clickOnThe(item.id)">

              <div class="dataFigure">
                <img
                  onerror="this.src='data:image/jpeg;base64,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'"
                  :src="imagePath(item.cover)">
              </div>

              <div class="theFollowingPicture">
                <div class="theFollowingHeadings">{{ item.courseName }}</div>
                <p class="belowTheTitle">主讲教师:{{ item.teacherName }}</p>
              </div>

            </li>
          </ul>
        </div>
        <div class="page clearfix" style="display: none">
          <div class="pager"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, watch } from "vue";
import {
  groupOfProfessionalTraining,
  theHomepageExperiment,
  homePageNavigation
} from "../assets/api/index";
import imagePath from "../assets/js/config.js";
import router from "../router/index.js";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex'

export default {

  setup() {



    const indexone = ref([0]);
    const indextwo = ref([0]);
    const professionalGroupOfData = ref([]);
    const professionalGroupOfDatas = ref([]);
    const professionalGroupOfDatasr = ref([]);
    const theSimulationlabel = ref([]);
    const theSimulationlabels = ref();




    //头部开始

    //首页导航
    const homePageNavigationRequest = reactive({
      parentId: 0,
    });

    const theNavigationDataAcquisition = ref([]);
    const secondaryNavigationData = ref([]);
    const headerads = () => {
      homePageNavigation(homePageNavigationRequest).then((res) => {
        theNavigationDataAcquisition.value = res.data;

      })
    };
    headerads();


    //获取二级导航分类
    const obtainTheSecondaryNavigationClassification = () => {
      homePageNavigation(homePageNavigationRequest).then((res) => {
        secondaryNavigationData.value = res.data;

      })
    };




    const whetherToClickOnTheLower = ref(false);
    const secondaryNavigationClassification = ref([]);
    const selectTheNumberOf = ref();
    const selectTheNumberOfs = ref(-1);
    //首页导航点击
    const columnClick = (value, index) => {
      homePageNavigationRequest.parentId = value;

      whetherToClickOnTheLower.value = true;
      selectTheNumberOf.value = index;
      selectTheNumberOfs.value = index;
      obtainTheSecondaryNavigationClassification();



    };
    //移除样式
    const removeTheStyle = () => {


      secondaryNavigationData.value = [];
      whetherToClickOnTheLower.value = false;
    };

    //返回首页
    const secondaryToChangeColor = ref([localStorage.getItem("parentId")]);
    const returnToTheHomePage = () => {
      router.push('/liaoningTraffic')
      localStorage.setItem("parentId", -1);

      secondaryToChangeColor.value = -1;

    };


    //二级跳转



    const clickOnTheSecondJump = (id, parentId) => {




      localStorage.setItem("parentId", parentId - 1);
      id = id - 6;
      router.push({ path: 'theListOf', query: { roadId: id } })
      secondaryToChangeColor.value = parentId - 1;


      // setTimeout(function () {
      //   location.reload();
      // }, 10);
    };


    //头部结束



























    const store = useStore();


    const Route = useRoute();
    //获取实验
    const theExperimentalDataRequest = reactive({
      nId: null,
      teacherName: null,
      vrName: null,



    });
    const theExperimentalData = ref([]);
    const numberOfTraining = ref([]);
    const theExperimentRequest = () => {
      theHomepageExperiment(theExperimentalDataRequest).then((res) => {
        theExperimentalData.value = res.rows;
        numberOfTraining.value = res.total;
      })
    };


    //搜索关键词和教师
    const theNameOfTheSearch = () => {
      theExperimentRequest();
    };

    //专业群


    const professionalGroupOfAccess = () => {

      groupOfProfessionalTraining().then((res) => {

        professionalGroupOfData.value = res.navigations;
        let yiji = res.navigations[indexone.value].children;
        theSimulationlabel.value = res.navigations[indexone.value].label;
        professionalGroupOfDatas.value = yiji;

        if (yiji == '') {
          professionalGroupOfDatasr.value = [];
        } else {
          let erji = yiji;
          professionalGroupOfDatasr.value = erji[indextwo.value].children;
        }

        theExperimentRequest();


        console.log(999, yiji)
        //获取一级分类下选择的二级目录
        // yiji.forEach(item => {
        //   professionalGroupOfDatas.value.push(item.children)

        // });


      })
    };
    professionalGroupOfAccess();


    //专业群点击

    //一级分类点击
    const currentIndex = ref(-1);
    const currentIndexej = ref(-1);
    const currentIndexsj = ref(-1);
    const theSecondaryNumbers = ref(0);
    const theSecondaryNumbersr = ref(0);
    const theSecondaryNumbersrx = ref(0);





    const clickOnTheClassifications = (value, index) => {



      theSecondaryClassificationClicks('', -1);
      level3DirectoryClick('', -1);

      currentIndex.value = index;
      if (index == -1 || value == '') {
        theExperimentalDataRequest.nId = null;
        theExperimentRequest();

      } else {

        indexone.value = index;
        professionalGroupOfAccess();
        // theSecondaryNumbers.value = index;

        theExperimentalDataRequest.nId = value;

      }
    };


    //访问路径


    const clickOnTheClassification = (value, index, level, label) => {
      theSimulationlabel.value = label;


      localStorage.setItem("parentId", level - 1);

      // store.commit('count', level)
      secondaryToChangeColor.value = level - 1;
      // store.count = level;


      theSecondaryClassificationClicks('', -1);
      level3DirectoryClick('', -1);

      currentIndex.value = index;
      if (index == -1 || value == '') {
        theExperimentalDataRequest.nId = null;


      } else {

        indexone.value = index;
        professionalGroupOfAccess();
        // theSecondaryNumbers.value = index;

        theExperimentalDataRequest.nId = value;

      }
    };

   

    //二级目录点击
    const theSecondaryClassificationClicks = (value, index, label) => {

      theSimulationlabels.value = label;




      level3DirectoryClick('', -1);
      currentIndexej.value = index;
      if (index == -1 || value == '') {
        theExperimentalDataRequest.nId = null;

      } else {
        theExperimentalDataRequest.nId = value;
        theSecondaryNumbersr.value = index;

        indextwo.value = index;
        professionalGroupOfAccess();

      }
    };



    const theSecondaryClassificationClicksr = (value, index) => {

      professionalGroupOfDatasr.value = [];
      level3DirectoryClick('', index)

      currentIndexej.value = index;
      if (index == -1 || value == '') {
        theExperimentalDataRequest.nId = null;
        theExperimentRequest();
      } else {
        theExperimentalDataRequest.nId = value;
        theSecondaryNumbersr.value = index;

        indextwo.value = index;


      }
    };

    //三级目录点击
    const theSimulationlabelsr = ref();
    const level3DirectoryClick = (value, index, label) => {
      theSimulationlabelsr.value = label;





      currentIndexsj.value = index;
      if (index == -1 || value == '') {
        theExperimentalDataRequest.nId = null;

      } else {
        theSecondaryNumbersrx.value = index;
        theExperimentalDataRequest.nId = value;

        theExperimentRequest();
      }
    };

    const level3DirectoryClicks = (value, index) => {
      currentIndexsj.value = index;
      if (index == -1 || value == '') {
        theExperimentalDataRequest.nId = null;
        theExperimentRequest();
      } else {
        theSecondaryNumbersrx.value = index;
        theExperimentalDataRequest.nId = value;

        theExperimentRequest();
      }
    };



    if (Route.query.roadId == undefined) {
      router.push({ path: 'theListOf', query: { roadId: 0 } })
    } else {
      currentIndex.value = Route.query.roadId;
      theExperimentalDataRequest.nId = currentIndex.value + 6;
      indexone.value = Route.query.roadId;



      currentIndexej.value = Route.query.roadIds;
      indextwo.value = Route.query.roadIds;
    
    }




    //二级分类点击





    const ccc = (value) => {
      return value.substr(0, 4);
    };


    //点击实验

    const clickOnThe = (value) => {
      router.push({ path: "projectDetails", query: { theId: value } });
    };

    return {
      imagePath,
      ccc,

      theNameOfTheSearch,
      theSimulationlabel,
      theSimulationlabels,
      theSimulationlabelsr,
      //专业群
      professionalGroupOfData,
      professionalGroupOfDatas,
      professionalGroupOfDatasr,
      professionalGroupOfAccess,
      //专业群点击
      currentIndex,
      currentIndexej,
      currentIndexsj,
      clickOnTheClassification,
      clickOnTheClassifications,
      theSecondaryNumbers,
      theSecondaryNumbersr,
      theSecondaryNumbersrx,
      level3DirectoryClick,
      level3DirectoryClicks,
      theSecondaryClassificationClicks,
      theSecondaryClassificationClicksr,
      indexone,
      indextwo,
      //获取实验
      theExperimentalData,
      theExperimentRequest,
      numberOfTraining,
      //点击实验
      clickOnThe,
      theExperimentalDataRequest,




      //头部开始
      //首页导航
      secondaryToChangeColor,
      clickOnTheSecondJump,
      headerads,
      theNavigationDataAcquisition,
      homePageNavigationRequest,
      whetherToClickOnTheLower,
      selectTheNumberOf,
      selectTheNumberOfs,
      obtainTheSecondaryNavigationClassification,

      secondaryNavigationData,
      removeTheStyle,
      //首页点击
      columnClick,
      returnToTheHomePage,


      //头部结束
    };
  },


  name: "HelloWorld",
};
</script>

<style scoped>
@import "../assets/css/common.css";
@import "../assets/css/list-page.css";

/**头部数据 */
.header {
  height: 200px;
  background: #fff;
}

.loginOut {
  color: #a50c0d;
  margin-left: 8px;
  cursor: pointer;
}


.homePageStyle {
  width: 100px;
  display: inline-block;
  border-top: 3px solid #6e0013;
  line-height: 43px;
  color: #6e0013;
  font-weight: bold;
}

.theSecondaryClassificationOfUl li {
  background: #ce3032;
  border-bottom: 1px solid #de7475;
  padding: 0 15px 0 15px;
  min-width: 250px;
  text-align: start;
}

.theSecondaryClassificationOfUl li {
  color: #FFF;
}

.theSecondaryClassificationOfUl li:hover {
  background: #a50c0d;
}




.trainingCenterStyle {
  border-top: 2px solid #6e0013;
  display: inline-block;
  background: #a50c0d;
  width: 100%;
  color: #FFF;
  height: 47px;
  line-height: 47px;

}

.secondaryNavigationDropdown {
  position: relative;
  bottom: 3px;
}

/**头部数据结束 */

.dataFigure img {
  width: 100%;
  height: 175px;
}

.theFollowingPicture {
  margin-top: 14px;
  font-size: 15px;
}

.belowTheTitle {
  margin-top: 14px;
  font-size: 14px;
  color: #999999;
}

.classificationOfBackground {
  background: #fff;
}

.theNumberOfIco {
  margin-right: 2px;
  position: relative;
  top: 2px;
}

.pfhmtb img {
  width: 16px;
  height: 13px;
  position: relative;
  top: 2px;
}

.onTheLeftSideOfThePicture {
  float: left;
  position: relative;
  bottom: 4px;
  margin-right: 9px;
  width: 25px;
  height: 20px;
}

.declarePictures img {
  width: 16px;
  height: 16px;
}

.bg_nr p {
  font-size: 13px;
}

.detailsList {
  width: 1290px;
}

.keywords {
  margin-left: 14px;
}
</style>